<template>
  <div>
    <div v-if="isSelectedPromotion() === true" id="promotion-detail" style="margin-bottom: 50px">
      <table id="table-special-offer-promotion-detail" style="width: 100%">
        <tr>
          <td>
            <p>Promotion Code: </p>
          </td>
          <td>
            <p>{{bindData(specialOfferDetail, 'promotion.code', '-')}}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Period of stay: </p>
          </td>
          <td>
            <p v-html="bindPromotionPeriod()"></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Booking period: </p>
          </td>
          <td>
            <p>{{bindBookingPeriod()}}</p>
          </td>
        </tr>
        <tr>
          <td style="padding: 20px 0">
            <p>Room types: </p>
          </td>
          <td style="padding: 20px 0">
            <p>{{bindRoomTypeList()}}</p>
          </td>
        </tr>
        <tr>
          <td style="padding: 20px 0">
            <p>Promotion details: </p>
          </td>
          <td style="padding: 20px 0">
            <p>{{bindData(specialOfferDetail, 'promotion.detail', '-')}}</p>
          </td>
        </tr>
        <tr>
          <td style="padding: 20px 0">
            <p>Allotment: </p>
          </td>
          <td style="padding: 20px 0">
            <table v-if="hasAllotment()"
                   style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%; margin-bottom: 20px;">
              <tr style="background-color: #f3f3f3">
                <th style="border: 1px solid #cccccc; padding: 5px 10px; text-align: left;">
                  <p style="margin: 0">Room Type</p>
                </th>
                <th style="border: 1px solid #cccccc; padding: 5px 10px; text-align: left;">
                  <p style="margin: 0">Cutoff Date</p>
                </th>
                <th style="border: 1px solid #cccccc; padding: 5px 10px; text-align: left;">
                  <p style="margin: 0">Allotment</p>
                </th>
              </tr>
              <tr v-for="(roomType, index) of roomTypeTableList" :key="`room-type-list-${index}`">
                <td style="border: 1px solid #cccccc; padding: 5px 10px;">
                  <p style="margin: 0">{{roomType.name}}</p>
                </td>
                <td style="border: 1px solid #cccccc; padding: 5px 10px;">
                  <p style="margin: 0" v-if="roomType.cutoffDate !== ''">{{roomType.cutoffDate}}</p>
                  <p style="margin: 0" v-if="roomType.cutoffDate === ''"> - </p>
                </td>
                <td style="border: 1px solid #cccccc; padding: 5px 10px;">
                  <p style="margin: 0" v-if="roomType.allotment !== ''">{{roomType.allotment}}</p>
                  <p style="margin: 0" v-if="roomType.allotment === ''"> - </p>
                </td>
              </tr>
            </table>
            <p v-else> - </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Remark: </p>
          </td>
          <td v-html="bindData(specialOfferDetail, 'promotion.remark', '-')"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'
import { bindData } from '@/helpers'
import { get } from 'lodash'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'PromotionDetailComponent',
  props: {
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          autoRefCode: STATUS.DISABLE,
          status: SPECIAL_OFFER_STATUS.DRAFT,
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          hotel: {
            id: '',
            information: {
              code: '',
              name: ''
            },
            salePerson: {
              id: '',
              title: '',
              firstName: '',
              lastName: '',
              position: '',
              email: '',
              updatedAt: ''
            }
          },
          promotion: {
            promotion: {
              id: '',
              code: '',
              detail: '',
              minNight: 0,
              maxNight: 0,
              isEnable: 0,
              updatedAt: 0,
              bookingPeriod: {
                startDate: '',
                endDate: ''
              },
              periodOfStayList: [],
              isEnableAllotment: 0,
              roomTypeList: []
            }
          },
          agentList: [],
          general: {
            startDate: '',
            endDate: '',
            issueDate: '',
            internalNote: '',
            footerMessage: '',
            bodyMessage: ''
          }
        }
      }
    }
  },
  data () {
    return {
      bindData
    }
  },
  computed: {
    roomTypeTableList: {
      get () {
        const roomTypeList = get(this.specialOfferDetail, 'promotion.roomTypeList', [])
        if (roomTypeList.length === 0) {
          return []
        }
        const cloneRoomTypeList = [...roomTypeList]
        const sortedRoomTypeList = cloneRoomTypeList.sort((a, b) => {
          return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1
        })

        return sortedRoomTypeList
      }
    }
  },
  methods: {
    isSelectedPromotion: function () {
      const promotionId = get(this.specialOfferDetail, 'promotion.id', undefined)
      return (promotionId !== undefined)
    },
    bindPromotionPeriod: function () {
      const periodList = get(this.specialOfferDetail, 'promotion.periodOfStayList', [])
      let periodStayStrList = []

      for (let period of periodList) {
        const periodStr = this._getDateFromTo(period.startDate, period.endDate)
        periodStayStrList.push(periodStr)
      }

      return periodStayStrList.join(', <br />')
    },
    bindBookingPeriod: function () {
      let bookingPeriodStr = '-'
      const promotion = get(this.specialOfferDetail, 'promotion', {})
      const startDateStr = get(promotion, 'bookingPeriod.startDate', '')
      const endDateStr = get(promotion, 'bookingPeriod.endDate', '')

      if (startDateStr !== '' && endDateStr !== '') {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)
        bookingPeriodStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return bookingPeriodStr
    },
    bindRoomTypeList: function () {
      const promotion = get(this.specialOfferDetail, 'promotion', {})
      const roomTypeList = get(promotion, 'roomTypeList', [])

      const roomTypeNameList = roomTypeList.map(roomType => roomType.name)
      const roomTypeNameListStr = (roomTypeNameList.length > 0) ? roomTypeNameList.join(', ') : '-'

      return roomTypeNameListStr
    },
    _getDateFromTo: function (startDateStr, endDateStr) {
      let dateFromToStr = '-'
      if (startDateStr !== undefined && endDateStr !== undefined) {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)
        dateFromToStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return dateFromToStr
    },
    hasAllotment: function () {
      const isEnableAllotment = Boolean(get(this.specialOfferDetail, 'promotion.isEnableAllotment', 0))
      return isEnableAllotment
    }
  }
}
</script>

<style scoped>
  #table-special-offer-promotion-detail > tr > td:nth-child(1) {
    vertical-align: top;
    font-weight: bold;
    width: 20%;
    padding: 5px 0;
  }
  #table-special-offer-promotion-detail > tr > td:nth-child(2) {
    width: 80%;
    padding: 5px 0;
    margin: 0;
  }
</style>
